import React from 'react';
import Select from 'react-select';
import { ORDER_TYPES } from '../helpers/orderType';

/**
 * Order-type filter for the booking overviews, rendered as a dropdown like the other filters.
 * `value` is 'all' | 'standard' | 'kind' | 'copywrite'; clearing the dropdown means 'all'.
 *
 * Replaces the old KIND on/off toggle, which could only tell KIND orders apart from everything
 * else. The order type comes from bookings.order_type (with a set-name fallback for old rows,
 * see helpers/orderType.js).
 */
export const ORDER_TYPE_FILTER_OPTIONS = [
  { value: ORDER_TYPES.STANDARD, label: 'Standard' },
  { value: ORDER_TYPES.KIND, label: 'KIND / CGI' },
  { value: ORDER_TYPES.COPYWRITE, label: 'Copywrite' },
];

export const orderTypeFilterLabel = (value) =>
  ORDER_TYPE_FILTER_OPTIONS.find((o) => o.value === value)?.label || 'All';

const OrderTypeFilter = ({ value = 'all', onChange, styles, components, placeholder = 'Filter by Order Type' }) => (
  <Select
    inputId="order-type-filter"
    value={ORDER_TYPE_FILTER_OPTIONS.find((o) => o.value === value) || null}
    onChange={(option) => onChange && onChange(option ? option.value : 'all')}
    options={ORDER_TYPE_FILTER_OPTIONS}
    isClearable
    placeholder={placeholder}
    styles={styles}
    components={components}
  />
);

export default OrderTypeFilter;
